import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  button: {
    fontWeight: isKiteUser ? '400' : '600',
    fontSize: '16px',
    lineHeight: '20px',
    color: `${theme.palette.primary1} !important`,
  },
}));
